import { useFetchGrinScanForScanTaggingQuery } from 'store/modules/ScanTagging'
import { getNewMediaBucket } from 'utils/mediaUtils'

export default ({ scanId }) => {
  const { data: grinScan } = useFetchGrinScanForScanTaggingQuery({ grinScanId: scanId }, { skip: !scanId })
  const newMediaBucket = getNewMediaBucket()

  const parsedScanSummary = JSON.parse(grinScan?.scanSummaryData || '{}')
  const oralHygieneRecommendationImages =
    parsedScanSummary?.recommendations_dict?.brushing_technique?.map(recImage => ({
      key: recImage?.img_path?.replace(`s3://${newMediaBucket}/`, ''),
      bucket: newMediaBucket
    })) || []

  return {
    oralHygieneRecommendationImages
  }
}
